module.exports = __webpack_public_path__ + "static/media/sort-alpha-down.e5132a75.svg";